import * as Yup from 'yup';

const RewardDetailFormSchema = Yup.object().shape({
  quantity: Yup.number().integer().min(1).required('Please enter a quantity'),
});

export default RewardDetailFormSchema;
